<template>
  <router-view/>

  <div class="tab-btn" v-if="route.path === '/shop' || route.path === '/my' ">
    <router-link class="_item" :class="route.path === '/shop' ? 'on' : ''" to="/shop">
      <i class="iconfont icon-a-shangchengdaohang"></i>
      <div>商城</div>
    </router-link>
    <router-link class="_item" :class="route.path === '/my' ? 'on' : ''" to="/my">
      <i class="iconfont icon-a-wodedaohang"></i>
      <div>我的</div>
    </router-link>
    <div class="tag-bg" :class="route.path === '/shop' ? 'on' : ''"></div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<style lang="scss">

</style>
